import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const track = (event, meta = {}) => {
  try {
    const payload = { event, path: window.location.pathname, ...meta };
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      navigator.sendBeacon(`${API}/track`, blob);
    } else {
      axios.post(`${API}/track`, payload).catch(() => {});
    }
  } catch (e) {
    /* analytics must never break the page */
  }
};

export const trackPageView = () => track("page_view");
export const trackAppStoreClick = () => track("appstore_click");
